// extracted by mini-css-extract-plugin
module.exports = {"root":"SheetFooter_root__RCSuX","leftButton":"SheetFooter_leftButton__3OqCJ"};